import React, { Component } from 'react';
import BarChart from './BarChart';

const InvoicesClientChart = ({labels, datasets, colors, custom_client_name = 'Client'}) => {
  return(
    <>
      <h3>{`Invoices Per ${custom_client_name}`}</h3>
      <div className="space-12" />
      <BarChart
        {...{
          labels,
          datasets,
          colors,
          swapRowsColumns: true,
          horizontalColors: true,
          horizontalTotal: true,
          verticalTotal: true,
          useCurrency: true,
          rightAlign: true
        }}
      />
    </>
  )
};

export default InvoicesClientChart;
